import React from 'react';
import animationData from '../../Lottie.json';
import Lottie from 'lottie-react';
import logoIcon from "../../assests/logo_ic_new.png";
 
export default function Loader() {
    return (
        <div>
            <Lottie
                style={{
                    width: 200,
                    height: 200,
                    position: 'fixed',
                    top: 0,
                    bottom: 0,
                    margin: 'auto',
                    aspectRatio: 300 / 600,
                    flexGrow: 1,
                    alignSelf: 'center',
                }}
                // autosize
                resizemode="cover"
                className="spinLoader"
                animationData={animationData}
                loop={true}
                autoplay={true}>
            </Lottie>
            <img src={logoIcon} style={{
                height: "50px",
                width: "50px",
                margin: "auto",
                position: "fixed",
                left: "0",
                right: "0",
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 5
            }} />
        </div>
    )
}